import { CustomTextField } from "../../../../../components/CustomTextField";
import CustomModal from "../../../../../components/Modal/CustomModal";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * Modal component for rejecting a request with a comment input.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.show - Controls the visibility of the modal.
 * @param {Function} [props.onHide=() => {}] - Callback function triggered when closing the modal.
 * @param {Function} [props.onConfirm=() => {}] - Callback function triggered when confirming the rejection.
 * @param {Object} props.data - Data object containing form values.
 * @param {Function} props.handleChange - Handler function to update input values.
 * @param {boolean} props.emptyFields - Indicates if required fields are empty.
 * @returns {JSX.Element} The rendered RejectRequestModal component.
 */

const RejectRequestModal = ({
    show,
    onHide = () => { },
    onConfirm = () => { },
    data,
    handleChange,
    emptyFields
}) => {

    return (
        <div>
            <CustomModal
                show={show}
                onHide={() => onHide()}
                title="reject_request"
                onConfirm={() => onConfirm()}
            >
                <CustomTextField
                    id='txt_rrm_introduction'
                    length={512}
                    name='comment'
                    value={data?.comment}
                    trans={'comment'}
                    type='text'
                    onChange={handleChange}
                    multiline={true}
                    required
                    emptyFields={emptyFields}
                />
            </CustomModal>
        </div >
    )
}

export default RejectRequestModal